import { render, staticRenderFns } from "./VEditor.vue?vue&type=template&id=18c3bb7a&"
import script from "./VEditor.vue?vue&type=script&lang=js&"
export * from "./VEditor.vue?vue&type=script&lang=js&"
import style0 from "./VEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports